import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import baseStyles from './styles/baseStyles';
import Colours from '../tokens/colours';
const getStyles = createUseStyles({
    root: {
        ...baseStyles,
        border: `1px solid ${Colours.darkBlue}`,
        backgroundColor: Colours.alabaster,
        borderRadius: "4px"
    }
});
const Input = ({ className, placeholder }) => {
    const styles = getStyles();
    return React.createElement("input", { placeholder: placeholder, className: classNames(styles.root, className) });
};
export default Input;
//# sourceMappingURL=Input.js.map